export default theme => ({
  emailDisplay: {
    fontSize: `${theme.textSizes[1]}px !important`,
    fontWeight: "normal !important",
    color: theme.palette.link.dark,
  },
  emailDisplay__link: {
    textDecoration: "none",
    whiteSpace: "pre-wrap",
    cursor: "pointer",
  },
});
